'use strict';

module.exports = /^[-~!$%^&*=+}{'?\w]+(?:\.[-~!$%^&*=+}{'?\w]+)*@(?:(?:[a-z\d][-a-z\d]*(?:\.[a-z\d][-a-z\d]*)*\.[a-z][a-z\d]*)|(?:(?:\d{1,3}\.){3}\d{1,3}(?::\d{1,5})?))$/i;
